/**
 * usePageVisibility — Track document.visibilityState for SubscriptionScope pausing.
 *
 * Returns `true` when the page is visible, `false` when hidden.
 * Subscribes to the `visibilitychange` event and cleans up on unmount.
 *
 * Consumed by SubscriptionScope (FR-007, NFR-011) to pause Convex
 * subscriptions when the tab is in the background, reducing subscription
 * burst cost on multi-tab sessions.
 */
import { useState, useEffect, useCallback } from "react";

export function usePageVisibility(): boolean {
  const [visible, setVisible] = useState<boolean>(
    () => document.visibilityState === "visible",
  );

  const handleVisibilityChange = useCallback(() => {
    setVisible(document.visibilityState === "visible");
  }, []);

  useEffect(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [handleVisibilityChange]);

  return visible;
}
